import { render, staticRenderFns } from "./howTakePrintModal.vue?vue&type=template&id=adbb8638"
import script from "./howTakePrintModal.vue?vue&type=script&lang=js"
export * from "./howTakePrintModal.vue?vue&type=script&lang=js"
import style0 from "./howTakePrintModal.vue?vue&type=style&index=0&id=adbb8638&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports